import { ButtonTs, ResponsiveModal } from '@lt/components';
import { i18n } from '@lt/localization';
import React from 'react';
import styles from './orderError.module.css';

type Props = {
  title: string;
  message?: string;
  onRetry?: () => void;
  orderNumber?: number;
  goToOrder?: () => void;
  contactPhone?: string;
  isOpened: boolean;
  closePopup: () => void;
  reasons?: string[];
};

const OrderError = (props: Props) => {
  const {
    title,
    message,
    onRetry,
    orderNumber,
    goToOrder,
    contactPhone,
    isOpened,
    closePopup,
    reasons = [],
  } = props;

  if (!isOpened) return null;

  return (
    <ResponsiveModal
      center
      open
      onClose={closePopup}
      showCloseIcon
      styles={{ modal: { borderRadius: 6 } }}
    >
      <div className={styles.popupContainer} data-testid="ORDER_ERROR_POPUP">
        <div className={styles.errorIcon} />
        <div className={styles.errorTitle}>{title}</div>
        <div className={styles.errorMessage}>
          <span className={styles.bold}>
            {i18n.t('checkout.error.possibleReasons')}
          </span>
          {reasons.map((reason) => (
            <div key={reason} className={styles.reason}>
              {reason}
            </div>
          ))}
          <div>{message}</div>
          {orderNumber ? (
            <div className={styles.withOrderNumber}>
              {onRetry && (
                <ButtonTs onClick={onRetry} variant="primary">
                  {i18n.t('subscribe.retry')}
                </ButtonTs>
              )}
              {goToOrder && (
                <ButtonTs
                  variant="functional"
                  onClick={goToOrder}
                  className={styles.goToOrderLink}
                >
                  {i18n.t('checkout.error.goToOrder')}
                </ButtonTs>
              )}
              <div>
                {contactPhone && (
                  <>
                    <span>
                      {i18n.t('checkout.error.contactUs', {
                        context: 'withRetry',
                      })}{' '}
                    </span>
                    <span>
                      {i18n.t('checkout.error.contactPhone', {
                        contactPhone,
                      })}
                    </span>
                  </>
                )}
                <div>
                  {i18n.t('checkout.error.orderNumber', {
                    context: 'withRetry',
                    orderNumber,
                  })}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default OrderError;
